import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

ReactModal.setAppElement('body');
ReactModal.defaultStyles.overlay.zIndex = '1600';

const customStyles = {
  content: {
    top: '0',
    width: 'calc(100% - 40px)',
    height: 'calc(100% - 40px)',
    left: '0',
    overflow: 'hidden',
    margin: '20px',
    paddingTop: '50px',
    paddingBottom: '10px',
    alignItems: 'center',
    justifyContent: 'space-around'
  }
};

const Modal = ({ children, isOpen, closeModal, afterOpenModal, styles, ...rest }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={styles || customStyles}
      {...rest}
    >
      {children}
    </ReactModal>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  afterOpenModal: PropTypes.func,
  closeModal: PropTypes.func,
  children: PropTypes.node.isRequired,
  styles: PropTypes.exact({ content: PropTypes.shape({}) })
};

Modal.defaultProps = {
  afterOpenModal: null,
  closeModal: null,
  styles: null
};

export default Modal;
